import React from 'react';
import {
  Routes,
  Route
} from 'react-router-dom';

import IndexPage from './pages/Index.js';
import RegisterPage from './pages/Register.js';
import LoginPage from './pages/Login.js';
import _404Page from './pages/404.js';
import _502Page from './pages/502.js';
import AccountantDashboardPage from './pages/Accountant_dashboard.js';
import StaffDashboardPage from './pages/Staff_dashboard.js';

function App() {
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
         
      <Route path="/register" element={<RegisterPage />} />
         
      <Route path="/login" element={<LoginPage />} />
         
      <Route path="/404" element={<_404Page />} />
         
      <Route path="/502" element={<_502Page />} />
         
      <Route path="/accountantdashboard" element={<AccountantDashboardPage />} />
         
      <Route path="/staffdashboard" element={<StaffDashboardPage />} />
    </Routes>
  );
}

export default App;
